import { createSlice } from '@reduxjs/toolkit'

const popupSlice = createSlice({
    name: 'popup', 
    initialState: {
        Component: null,
        isOpen: false 
    },
    reducers: {
        OpenModal: (state, action) => {
            return { 
                //...state,
                isOpen: true,
                Component: action.payload
              };
        },
        CloseModal: (state, action) => {
            return {
               // ...state,
                isOpen: false,
                Component: null
              };
        },
    }
})

export const { OpenModal, CloseModal } = popupSlice.actions

export default popupSlice.reducer
